
<template>
  <div class="flex flex-col">
    <div class="w-full">
      <LoginLogin v-if="userStore.activeRoute == 'login'" />
      <LoginRegister v-if="userStore.activeRoute == 'register'" />
      <ForgotPassword v-if="userStore.activeRoute == 'forgot'" />
    </div>
  </div>
</template>

<script setup>
import LoginLogin from "@/views/LoginView/LoginLogin.vue";
import LoginRegister from "@/views/LoginView/LoginRegister.vue";
import ForgotPassword from "@/views/LoginView/ForgotPassword.vue";
import { useUser } from '@/stores';
const userStore = useUser()

userStore.activeTab = 'login'

const lastNode = window.location.href.split("/").pop()
if (lastNode == 'logout') {
  userStore.signOutUser()
  userStore.user = null
  userStore.settings = null
  userStore.activeRoute = 'login'
} else {
  userStore.activeRoute = lastNode
}

// const activeRoute = computed(() => userStore.activeRoute);

</script>

<style></style>